/**
 * @page PreiskalkulatorPage
 * @route /preiskalkulator
 * @description Interner Preiskalkulator — Live-Berechnung von Fulfillment-Kosten.
 *   Uses shared CalculatorCore component with internal layout (v2 Sidebar + TopBar).
 */
import { useLanguage } from '../context/LanguageContext';
import { Calculator, FileDown, ExternalLink } from 'lucide-react';
import CalculatorCore, { formatPrice } from '../components/CalculatorCore';

export default function PreiskalkulatorPage() {
  const { t } = useLanguage();

  return (
    <div className="p-6">
      {/* ── Header ── */}
      <div className="flex items-center gap-3 mb-6">
        <div className="w-9 h-9 rounded-lg bg-[var(--primary-light,#EBF4FD)] flex items-center justify-center">
          <Calculator className="w-[18px] h-[18px] text-[var(--primary,#338edc)]" />
        </div>
        <div>
          <div className="flex items-center gap-2">
            <h1 className="text-lg font-semibold text-[var(--text-primary)]">{t('calculator.title')}</h1>
            <span className="px-2 py-0.5 rounded-full text-[11px] font-semibold bg-[var(--primary)] text-white">{t('calculator.internal')}</span>
          </div>
        </div>
      </div>

      <CalculatorCore mode="internal" />
    </div>
  );
}
